import { connect } from 'react-redux'
import './CtaGroup.scss'
import { LuxButton, LuxIcon, Color } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import { useEffect, useState } from 'react'

const CtaGroup = (props) => {
    const componentClass = 'smart-modals-cta-group'
    const { mode, ctaList, onCta, groupedText } = props
    const intl = useIntl()
    const [showMenu, setShowMenu] = useState(false)

    useEffect(() => {
        function handlerClick(ev) {
            let buttonActionEl =
                mode === 'button' || mode === 'buttonList'
                    ? document.querySelector('.smart-modals-cta-group__button-action')
                    : null
            let buttonActionLinkEl =
                mode === 'link'
                    ? document.querySelector('.smart-modals-cta-group__button-action-link')
                    : null
            let targetClasses = (ev.target as any).classList
            let found =
                false ||
                (!!buttonActionEl && buttonActionEl.contains(ev.target as any)) ||
                (!!buttonActionLinkEl && buttonActionLinkEl.contains(ev.target as any))
            for (let c of targetClasses) {
                buttonActionEl =
                    mode === 'button' || mode === 'buttonList'
                        ? document.querySelector('.smart-modals-cta-group__button-action')
                        : null
                buttonActionLinkEl =
                    mode === 'link'
                        ? document.querySelector('.smart-modals-cta-group__button-link-action')
                        : null
                found = !found
                    ? (!!buttonActionEl && c.includes('smart-modals-cta-group__button-action')) ||
                      (!!buttonActionLinkEl && c.includes('smart-modals-cta-group__button-link-action')) ||
                      c.includes('smart-wardrobe-button-icon-right') ||
                      (!!buttonActionEl && buttonActionEl.contains(ev.target as any)) ||
                      (!!buttonActionLinkEl && buttonActionLinkEl.contains(ev.target as any))
                    : found
            }
            if (!found) setShowMenu(found)
        }
        document.addEventListener('click', handlerClick)

        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('click', handlerClick)
        }
    })

    const singleCta = ctaList.map((cta, index) => (
        <LuxButton
            key={index}
            text={intl.formatMessage({
                id: cta.label,
                defaultMessage: cta.label.split('.').pop(),
            })}
            disabled={cta.disabled}
            onClick={() => onCta(cta.action)}
            variant={cta.variant}
        />
    ))

    const multipleCta = ctaList.map((cta, index) => (
        <div
            key={index}
            onClick={() => !cta.disabled && onCta(cta.action)}
            className={`${componentClass}-item ${cta.disabled ? 'disabled' : ''}`}
            role="button"
            tabIndex={0}>
            {cta.icon && <i className={`cu cu-${cta.icon}`} style={{ color: cta.disabled ? 'var(--lux-grey2)' : 'black' }}></i>}
            <h3>
                {intl.formatMessage({
                    id: cta.label,
                    defaultMessage: cta.label.split('.').pop(),
                })}
            </h3>
        </div>
    ))

    const multipleCtaOutlined = ctaList.map((cta, index) => (
        <LuxButton
            key={index}
            disabled={cta.disabled}
            variant={'outlined'}
            onClick={() => onCta(cta.action)}
            text={intl.formatMessage({
                id: cta.label,
                defaultMessage: cta.defaultLabel,
            })}
            style={{ marginLeft: '.4em' }}
        />
    ))

    return (
        <div className={componentClass}>
            {ctaList.length === 1 && singleCta}
            {ctaList.length > 1 && mode === 'button' && (
                <div className={`${componentClass}__grouped`}>
                    <div className={`${componentClass}__grouped-menu ${showMenu ? '' : 'hide'} ${mode === 'button' ? 'button-mode' : ''}`}>
                        {multipleCta}
                    </div>
                    <LuxButton
                        color={Color.WARNING}
                        text={groupedText}
                        onClick={() => setShowMenu((value) => !value)}
                        iconRight={showMenu ? 'caret-down' : 'caret-up'}
                        classes={`${componentClass}__button-action`}
                    />
                </div>
            )}
            {ctaList.length > 1 && mode === 'link' && (
                <div className={`${componentClass}__grouped`}>
                    <div className={`${componentClass}__grouped-menu ${showMenu ? '' : 'hide'}`}>
                        {multipleCta}
                    </div>
                    <div
                        className={`${componentClass}-link ${componentClass}__button-link-action`}
                        onClick={() => setShowMenu((value) => !value)}>
                        <span className="link" role="button" tabIndex={0}>
                            {groupedText}
                        </span>
                        <LuxIcon
                            icon={showMenu ? 'caret-down' : 'caret-up'}
                            color={Color.PRIMARY}
                        />
                    </div>
                </div>
            )}
            {ctaList.length > 1 && mode === 'buttonList' && (
                <div
                    className={`${componentClass}-item`}
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}>
                    {multipleCtaOutlined}
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(CtaGroup)
